import React from "react";
import Releves from "./Releves";


const RelevesAchat = () => {
    return <Releves tierLabel="Fournisseur" tiersApi="Suppliers" />;
};

export default RelevesAchat;
